  import { Eye, Trash2, Calendar, Ticket } from "lucide-react";

  export default function PromoRow({ promo, onView, onDelete }) {
    const now = new Date();
    const start = new Date(promo.startDate);
    const end = new Date(promo.endDate);

    const isPlanifiee = now < start;
    const isExpiree = now > end;
    const isActive = now >= start && now <= end;
    return (
      <tr>
        <td>
          <div className="userCell">
            <div
              className="headerIcon"
              style={{
                background: "#f0f9ff",
                padding: "8px",
                borderRadius: "8px",
              }}
            >
              <Ticket size={20} color="#0369a1" />
            </div>
            <div>
              <div
                className="userName"
                style={{ fontWeight: "bold", color: "#0369a1" }}
              >
                {promo.code}
              </div>
              {/* <div className="userSub">ID: {promo.id}</div> */}
            </div>
          </div>
        </td>
        <td>
          <div className="promoValue">
            {promo.percentage ? (
              <span className="badgePercent">{promo.percentage} %</span>
            ) : (
              <span className="badgeAmount">{promo.amount} CFA</span>
            )}
          </div>
        </td>
        <td>
          <span
            className={`typeBadge ${isActive ? "green" : isPlanifiee ? "yellow" : "red"}`}
          >
            {isActive ? "Active" : isPlanifiee ? "Planifiée" : "Expirée"}
          </span>
        </td>
        <td className="center">
          <div className="actions">
            <button
              className="iconBtn"
              onClick={() => onView(promo)}
              title="Détails"
            >
              <Eye size={18} />
            </button>
            <button
              className="iconBtn delete"
              onClick={() => onDelete(promo.id)}
              title="Supprimer"
            >
              <Trash2 size={18} color="#ef4444" />
            </button>
          </div>
        </td>
      </tr>
    );
  }
